import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcus G.',
    loc: '📍 Sydney | Head PE Teacher',
    quote: 'Finally, a resource that speaks the language of a real PE professional. I organized my entire 9-month school PE programming in a single afternoon. I never thought a resource could be this complete.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Florida | Physical Education Teacher',
    quote: "My lessons finally have a solid, professional structure. I don't spend Sunday nights on YouTube or Pinterest anymore. Having everything ready gave me my free time back."
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Spain | Certified PE Specialist',
    quote: 'The system saved me. I never walked into class improvising again, even when the schedule changed at the last minute. My students stay active, engaged, and love PE now.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Toronto | School Sports Coordinator',
    quote: 'Running a full PE program across multiple grade levels and having every session coordinated is a dream. The Visual Cue Pack changed the way my students understand even the toughest skills.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Buenos Aires | PE Teacher',
    quote: 'My classes are far more focused and energetic. What I value most is that everything is organized by skill level and season block. This is exactly what PE teachers need.'
  }, {
    initials: 'VT',
    name: 'Valerie T.',
    loc: '📍 London | Primary School PE Teacher',
    quote: 'The ready-made session plans with built-in assessments save me at least 3 hours every single week. It is like having an expert colleague who already did all the heavy lifting for me.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-243">
      <div className="max-w-6xl mx-auto" data-id="element-244">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-brand-ink mb-20 max-w-4xl mx-auto leading-tight" data-id="element-245">
          WHAT TEACHERS WHO ALREADY HAVE{' '}
          <span className="text-brand-accent" data-id="element-246">P.E. READY SAY:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-247">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border shadow-sm" data-id="element-248">
              <div className="flex items-center gap-5 mb-8" data-id="element-249">
                <div className="w-16 h-16 rounded-full bg-brand-accent/5 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-250">
                  {test.initials}
                </div>
                <div data-id="element-251">
                  <div className="text-brand-gold mb-2 text-sm" aria-label="5 stars" data-id="element-252">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-brand-ink text-xl mb-1" data-id="element-253">
                    {test.name}
                  </p>
                  <p className="text-sm text-brand-muted font-medium" data-id="element-254">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-brand-ink italic leading-relaxed text-lg" data-id="element-255">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}